// @flow @jsx h

import { PolopolyPicture } from '@nrk/dh-feature-components'
import { h } from 'preact'

import type { Slide } from './types'

type Props = Slide

function Background (props: Props) {
  // const { type } = props

  switch (props.type) {
    case 'image':
      return (
        <PolopolyPicture
          horizontal={{ id: props.horizontalId, quality: 'best' }}
        />
      )
    // return <img src={`${mediaBaseUrl}${value.src}`} alt='' />

    default:
      return <div>Slide</div>
  }
}

export default Background



// WEBPACK FOOTER //
// ./src/lib/@nrk/dh-feature-components/Slideshow/Background.js